import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Link,
  IconButton,
  Slide
} from '@mui/material';
import { Close } from '@mui/icons-material';

const CookieConsent: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted/declined cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show banner after a short delay for better UX
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <Slide direction="up" in={showBanner} mountOnEnter unmountOnExit>
      <Paper
        elevation={8}
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          backgroundColor: 'background.paper',
          borderTop: '2px solid',
          borderColor: 'primary.main',
          p: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 3,
          flexWrap: { xs: 'wrap', md: 'nowrap' }
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 600, mb: 1 }}>
            We use cookies
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            We use essential cookies to provide authentication and ensure the service works properly. 
            These cookies are necessary for the platform to function. 
            By continuing to use TextWiz, you agree to our use of cookies. 
            Learn more in our{' '}
            <Link href="/privacy" sx={{ color: 'primary.light', textDecoration: 'underline' }}>
              Privacy Policy
            </Link>.
          </Typography>
        </Box>

        <Box sx={{ 
          display: 'flex', 
          gap: 2, 
          flexShrink: 0,
          alignItems: 'center'
        }}>
          <Button
            variant="outlined"
            onClick={handleDecline}
            sx={{
              borderColor: 'text.secondary',
              color: 'text.secondary',
              textTransform: 'none',
              '&:hover': {
                borderColor: 'text.primary',
                backgroundColor: 'action.hover'
              }
            }}
          >
            Decline
          </Button>
          <Button
            variant="contained"
            onClick={handleAccept}
            sx={{
              backgroundColor: 'primary.main',
              color: 'white',
              textTransform: 'none',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: 'primary.dark'
              }
            }}
          >
            Accept Cookies
          </Button>
        </Box>

        <IconButton
          onClick={handleDecline}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'text.secondary'
          }}
        >
          <Close />
        </IconButton>
      </Paper>
    </Slide>
  );
};

export default CookieConsent;

